import img0 from "../images/0.jpg"
import img1 from "../images/1.png"
import img2 from "../images/2.png"
import img3 from "../images/3.png"
import img4 from "../images/4.png"
import img5 from "../images/5.png"
import img6 from "../images/6.png"
import img7 from "../images/7.png"
import img8 from "../images/8.jpg"
import img9 from "../images/9.png"
import img10 from "../images/10.png"
import img11 from "../images/11.png"
import img12 from "../images/12.png"
import img13 from "../images/13.jpg"
import img14 from "../images/14.png"
import img15 from "../images/15.jpeg"
import img16 from "../images/16.jpeg"



const data = [
{
    id:0,
    image:img0,
    alt:"first"
},
{
    id:1,
    image:img1,
    alt:"first"
},
{
    id:2,
    image:img2,
    alt:"first"
},

{
    id:3,
    image:img3,
    alt:"first"
},

{
    id:4,
    image:img4,
    alt:"first"
},

{
    id:5,
    image:img5,
    alt:"first"
},

{
    id:6,
    image:img6,
    alt:"first"
},
{
    id:7,
    image:img7,
    alt:"first"
},
{
    id:8,
    image:img8,
    alt:"first"
},
{
    id:9,
    image:img9,
    alt:"first"
},
{
    id:10,
    image:img10,
    alt:"first"
},
{
    id:11,
    image:img11,
    alt:"first"
},
{
    id:12,
    image:img12,
    alt:"first"
},
{
    id:13,
    image:img13,
    alt:"first"
},
{
    id:14,
    image:img14,
    alt:"first"
},
{
    id:15,
    image:img15,
    alt:"first"
},
{
    id:16,
    image:img16,
    alt:"first"
},

]

export default data